import React, { useEffect } from 'react';

export default function HealthPage() {
  useEffect(() => {
    // Set document title
    document.title = 'Health Check';
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'monospace'
    }}>
      <pre>{JSON.stringify({ status: 'ok', service: 'mercawatch-frontend' }, null, 2)}</pre>
    </div>
  );
}
